var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaregiverSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 16.1989C13.6473 16.1989 16.1988 13.6474 16.1988 10.5C16.1988 7.35262 13.6473 4.80115 10.4999 4.80115C7.35249 4.80115 4.80103 7.35262 4.80103 10.5C4.80103 13.6474 7.35249 16.1989 10.4999 16.1989Z",
    fill: "#EB4B62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5973 17.1873C10.9665 17.7209 10.0335 17.7209 9.40269 17.1873C6.85882 15.0355 3.80996 12.66 2.71599 9.55484C2.11495 7.84884 2.36435 5.86808 3.67761 4.55495C5.55576 2.67699 8.71837 2.98626 10.4243 6.44203C10.4547 6.5036 10.5453 6.5036 10.5757 6.44203C12.2816 2.98626 15.4442 2.67699 17.3224 4.55495C18.6356 5.86808 18.885 7.84884 18.284 9.55484C17.19 12.66 14.1412 15.0355 11.5973 17.1873Z",
    stroke: "#213332",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregiverSupport);
export default __webpack_public_path__ + "static/media/caregiver_support.f75789b7874d5a0186c4549f98c731d2.svg";
export { ForwardRef as ReactComponent };